import React from 'react';
import { TFunction } from 'i18next';
import { TaskCompletion } from 'graphql-common';
import { Column, CellProps } from '@lib/components/Table/types';
import IconButton, {
  IconButtonTypes,
} from '@lib/components/IconButton/IconButton';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import getTaskCompletionsTableColumns from '../../utils/getTaskCompletionsTableColumns';

// The completions modal's columns, read-only and without media, plus a
// "view" action when `onViewCompletion` is given.
export default function getCompletionsColumns({
  t,
  onViewCompletion,
}: {
  t: TFunction<'translation', undefined>;
  onViewCompletion?: (completion: TaskCompletion) => void;
}): Column<TaskCompletion>[] {
  const columns = getTaskCompletionsTableColumns({ t }).filter(
    ({ id }) => id !== 'media',
  );
  if (!onViewCompletion) return columns;
  return [
    ...columns,
    {
      id: 'view',
      Header: '',
      accessor: 'id',
      // A solved completion's row is disabled (unselectable — see
      // TaskCompletionsTableMultiselect), but it should still be viewable.
      prohibitDisabled: true,
      Cell: ({ item }: CellProps<TaskCompletion>) => (
        <Tooltip body={t('view')}>
          <IconButton
            type={IconButtonTypes.SecondaryOutlined}
            icon="visibility"
            symbolsOutlined
            onClick={() => onViewCompletion(item)}
          />
        </Tooltip>
      ),
      width: 1,
    },
  ];
}
